import ResizeObserver from 'resize-observer-polyfill';
import {gsap, Quart} from 'gsap/all';
import utils from '@/_modules/utils';

class _footer {
  //constructor() {}

  once() {
    this.isShow = false;
    this.el = document.getElementById('c-pagetop');
    if (this.el) {
      this.el.addEventListener('click', this.anchorTop.bind(this));
      window.addEventListener('scroll', this.scroll.bind(this));
      this.resize();
    }
  }

  init() {

  }

  scroll() {
    if (!this.isShow && utils.getScrollTop() > this.thresholdY) {
      this.isShow = true;
      this.el.classList.add('c-pagetop--show');
    } else if(this.isShow && utils.getScrollTop() < this.thresholdY) {
      this.isShow = false;
      this.el.classList.remove('c-pagetop--show');
    }
  }

  resize() {
    this.thresholdY = window.innerHeight * 1.2;
    this.scroll();
  }

  anchorTop() {
    gsap.to(window, {
      duration: 0.7,
      scrollTo: {
        y: 0,
        autoKill: false,
      },
      ease: Quart.easeOut
    });
  }
}

const footer = new _footer();

export default footer;